import { render, staticRenderFns } from "./AddressProjectAddress.vue?vue&type=template&id=c1479b60&scoped=true&lang=pug&"
import script from "./AddressProjectAddress.vue?vue&type=script&lang=ts&"
export * from "./AddressProjectAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1479b60",
  null
  
)

export default component.exports